import Button from "@/lib/Button";
import Input from "@/lib/Input";
import { useState } from "react";
import Layout from "./Layout";
import PasswordHint from "@/lib/PasswordHint";
import toast from "react-hot-toast";
import { useSearchParams, useNavigate } from "react-router";
import $api from "@/lib/queries/openapi";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [searchParams] = useSearchParams();
  const passwordResetKey = searchParams.get("reset-key") || "";
  const passwordValid =
    password.length && password === confirmPassword && passwordResetKey.length;

  const navigate = useNavigate();

  const { mutate: resetPassword } = $api.useMutation(
    "post",
    "/api/auth/password/reset",
    {
      onSuccess: () => {
        toast.success("Password reset successfully");
        navigate("/login");
      },
    },
  );

  return (
    <Layout title="Create a new password">
      <>
        <Input
          label="Password"
          value={password}
          onChange={setPassword}
          type="password"
          placeholder="Password"
        />
        <Input
          label="Confirm Password"
          value={confirmPassword}
          onChange={setConfirmPassword}
          type="password"
          placeholder="Confirm Password"
        />
        <Button
          primary
          size="lg"
          disabled={!passwordValid}
          onClick={() =>
            resetPassword({
              body: { password, key: passwordResetKey },
            })
          }
        >
          Save Password
        </Button>
        <PasswordHint />
      </>
    </Layout>
  );
}
